import { ClientPaymentAccountConstants as Constants } from '../types'
import { clientPaymentAccountsApi as api } from '../../api'

export const paymentAccountsAction = {
    get,
    credit,
    clear,
};

function get(clientId) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._get(clientId)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    }
    function success(payload) { return { type: Constants.GET, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function credit(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._credit(data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    }
    function success(payload) { return { type: Constants.CREDIT, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function clear() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(success());
            resolve()
        })
    }
    function success() { return { type: Constants.CLEAR } }
}